import React, { useState, useContext } from "react";
import VideoTracker from "./VideoTracker";
import AppContext from "./context";
import videos from "./videos";
import "./App.scss";

export default function App({}) {
  const [currentPlayingId, setCurrentPlayingId] = useState({
    id: null,
    isPlaying: false,
    haveEnoughData: false,
  });
  return (
    <AppContext.Provider value={{ currentPlayingId, setCurrentPlayingId }}>
      <div className="App">
        <div className="content-grid">
          <h6 className="section-header">VISIONARY VOICES</h6>
          <h1>
            Storytelling from anywhere, <br />
            accessible to everyone
          </h1>
          <p className="header-desc">
            In the coming decade, video entertainment will bring to life the
            creations of many more—and more diverse—storytellers across an
            expanding range of formats and channels.
          </p>
          <div className="videos">
            {videos.map((video, index) => (
              <VideoTracker key={index} video={video} order={index + 1} />
            ))}
          </div>
        </div>
      </div>
    </AppContext.Provider>
  );
}
